import { FC, PropsWithChildren, ReactNode, useState } from 'react';
import { IconButton } from '@mui/material';
import useId from '@mui/material/utils/useId';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import './CollapsibleSection.component.css';

export interface CollapsibleSectionProps {
    title: string;
    defaultCollapsed?: boolean;
    headerExtra?: ReactNode;
    className?: string;
}

export const CollapsibleSection: FC<PropsWithChildren<CollapsibleSectionProps>> = ({
    title,
    defaultCollapsed = false,
    headerExtra,
    className,
    children,
}) => {
    const [collapsed, setCollapsed] = useState<boolean>(defaultCollapsed);
    const bodyId = useId();

    return (
        <div className={`collapsible-section${className ? ` ${className}` : ''}`}>
            <div className="collapsible-section-header">
                <button
                    type="button"
                    className="collapsible-section-toggle"
                    aria-expanded={!collapsed}
                    aria-controls={bodyId}
                    onClick={() => setCollapsed((prev) => !prev)}
                >
                    <IconButton component="span" size="small" disableRipple>
                        {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </IconButton>
                    <span className="collapsible-section-title">{title}</span>
                </button>
                {headerExtra ? (
                    <div className="collapsible-section-header-extra">{headerExtra}</div>
                ) : null}
            </div>
            <div id={bodyId} hidden={collapsed} className="collapsible-section-body">
                {children}
            </div>
        </div>
    );
};
